import { Outlet, useLocation, useNavigationType } from "react-router-dom";
import { useEffect } from "react";
import { Header } from "@/components/store/Header";
import { Footer } from "@/components/store/Footer";
import { CartDrawer } from "@/components/store/CartDrawer";
import { SearchOverlay } from "@/components/store/SearchOverlay";
import { CookieBanner } from "@/components/store/CookieBanner";
import { useShop, useI18n } from "@/context/Shop";

export default function StoreLayout() {
  const { pathname } = useLocation();
  const navType = useNavigationType();
  const { config } = useShop();
  const { t } = useI18n();
  useEffect(() => {
    // keep scroll position on back/forward so listing filters + position are preserved
    if (navType !== "POP") window.scrollTo({ top: 0 });
  }, [pathname, navType]);
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] bg-foreground text-background px-4 py-2">{t("skip_to_content")}</a>
      {config?.demo_catalog && (
        <div className="bg-secondary text-[11px] text-center py-1.5 tracking-[0.06em] text-foreground/80" data-testid="demo-catalogue-banner">
          <span className="font-semibold uppercase mr-1">{t("demo")}</span> {t("demo_banner")}
        </div>
      )}
      <Header />
      <main id="main" className="flex-1"><Outlet /></main>
      <Footer />
      <CartDrawer />
      <SearchOverlay />
      <CookieBanner />
    </div>
  );
}
